import { render, staticRenderFns } from "./data_anak.vue?vue&type=template&id=114c09fc&"
import script from "./data_anak.vue?vue&type=script&lang=js&"
export * from "./data_anak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports